(function () {
  function cssEscape(val) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(val);
    return String(val).replace(/[^a-zA-Z0-9_\-]/g, function (ch) {
      return '\\' + ch;
    });
  }

  function handleize(val) {
    return String(val || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isMobileViewport() {
    try {
      return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
    } catch (e) {
      return false;
    }
  }

  function createSheet(sectionId, mountParent) {
    var selector = '[data-ymee-variant-sheet]';
    if (sectionId) selector = '[data-ymee-variant-sheet][data-ymee-variant-sheet-for="' + cssEscape(sectionId) + '"]';

    var existing = document.querySelector(selector);
    if (existing) {
      var existingBackdrop = null;
      try {
        existingBackdrop = document.querySelector(
          '[data-ymee-variant-sheet-backdrop][data-ymee-variant-sheet-for="' + cssEscape(sectionId) + '"]'
        );
      } catch (e) {
        existingBackdrop = document.querySelector('[data-ymee-variant-sheet-backdrop]');
      }

      return {
        sheet: existing,
        body: existing.querySelector('[data-ymee-variant-sheet-body]'),
        footer: existing.querySelector('[data-ymee-variant-sheet-footer]'),
        footerSize: existing.querySelector('[data-ymee-variant-sheet-footer-size]'),
        footerAddBtn: existing.querySelector('[data-ymee-variant-sheet-footer-add]'),
        footerAccelSlot: existing.querySelector('[data-ymee-variant-sheet-footer-accelerated-slot]'),
        closeBtn: existing.querySelector('[data-ymee-variant-sheet-close]'),
        backdrop: existingBackdrop,
      };
    }

    var backdrop = document.createElement('div');
    backdrop.className = 'ymee-variant-sheet-backdrop';
    backdrop.setAttribute('data-ymee-variant-sheet-backdrop', '');
    if (sectionId) backdrop.setAttribute('data-ymee-variant-sheet-for', sectionId);
    backdrop.hidden = true;

    var sheet = document.createElement('div');
    sheet.className = 'ymee-variant-sheet';
    sheet.setAttribute('data-ymee-variant-sheet', '');
    if (sectionId) sheet.setAttribute('data-ymee-variant-sheet-for', sectionId);
    sheet.hidden = true;

    var header = document.createElement('div');
    header.className = 'ymee-variant-sheet__header';
    
    var title = document.createElement('div');
    title.className = 'ymee-variant-sheet__title';
    title.textContent = window.selectSizeText;

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ymee-variant-sheet__close';
    closeBtn.innerHTML = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L13 13" stroke="var(--color-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="visually-hidden">{{ "general.close" | t }}</span>';
    closeBtn.setAttribute('data-ymee-variant-sheet-close', '');

    header.appendChild(title);
    header.appendChild(closeBtn);

    var productEl = document.querySelector('.product-single');
if (productEl) {
  var tags = (productEl.getAttribute('data-product-tags') || '').split(',');
  var stock = parseInt(productEl.getAttribute('data-product-stock') || '1', 10);
  if (tags.includes('PRE_FW26') && stock <= 0) {
    var lang = document.documentElement.lang || 'en';
    var messages = {
      'it': 'Questo prodotto sarà presto disponibile.',
      'es': 'Este producto estará disponible próximamente.',
      'ko': '이 제품은 곧 입고될 예정입니다.'
    };
    var msg = document.createElement('p');
    msg.textContent = messages[lang] || 'This product will be available soon.';
    msg.style.cssText = "font-family:'Montserrat',sans-serif;font-size:12px;font-weight:500;margin:8px 16px 0;color:#fff;";
    header.style.flexWrap = 'wrap';
msg.style.cssText = "font-family:'Montserrat',sans-serif;font-size:12px;font-weight:500;margin:4px 0 0;color:#fff;width:100%;display:block;";
header.appendChild(msg);
  }
}

    var body = document.createElement('div');
    body.className = 'ymee-variant-sheet__body';
    body.setAttribute('data-ymee-variant-sheet-body', '');

    var footer = document.createElement('div');
    footer.className = 'ymee-variant-sheet__footer';
    footer.setAttribute('data-ymee-variant-sheet-footer', '');

    var footerActions = document.createElement('div');
    footerActions.className = 'ymee-variant-sheet__footer-actions';

    var footerAddBtn = document.createElement('button');
    footerAddBtn.type = 'button';
    footerAddBtn.className = 'btn btn-primary btn-l btn__add-to-cart ymee-variant-sheet__footer-add';
    footerAddBtn.setAttribute('data-ymee-variant-sheet-footer-add', '');
    // footerAddBtn.textContent = 'Add to cart';
    footerAddBtn.innerHTML = '<span>Add to cart</span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none"><path d="M11.6743 2.31975H8.90169C8.72257 1.44146 8.13443 0.693448 7.30904 0.297231C6.4837 -0.0990771 5.51653 -0.0990771 4.69109 0.297231C3.86575 0.69354 3.27761 1.44151 3.09844 2.31975H0.325855C0.146118 2.31975 0 2.46197 0 2.63691V13.6822C0 13.7667 0.0342366 13.8471 0.0953744 13.9066C0.15651 13.9661 0.239657 14 0.325867 14H11.6741C11.7603 14 11.8435 13.9661 11.9046 13.9066C11.9658 13.8471 12 13.7667 12 13.6822V2.63691C12 2.46197 11.854 2.31975 11.6743 2.31975ZM6.00014 0.634648C6.51124 0.635838 7.00768 0.801863 7.41118 1.10653C7.81468 1.41179 8.10325 1.83844 8.23103 2.31983H3.76923C3.897 1.83843 4.18558 1.41179 4.58908 1.10653C4.99258 0.801863 5.48904 0.635851 6.00014 0.634648ZM11.3478 13.3651H0.652492V2.95467H3.04178V4.26438C3.04178 4.43992 3.1879 4.58154 3.36764 4.58154C3.54798 4.58154 3.6941 4.43992 3.6941 4.26438V2.95467H8.30631V4.26438C8.30631 4.43992 8.45243 4.58154 8.63278 4.58154C8.81251 4.58154 8.95863 4.43992 8.95863 4.26438V2.95467H11.3479L11.3478 13.3651Z" fill="black"/></svg>';

    var footerAccelSlot = document.createElement('div');
    footerAccelSlot.className = 'ymee-variant-sheet__footer-accelerated-slot';
    footerAccelSlot.setAttribute('data-ymee-variant-sheet-footer-accelerated-slot', '');

    footerActions.appendChild(footerAddBtn);
    footerActions.appendChild(footerAccelSlot);
    footer.appendChild(footerActions);

    sheet.appendChild(header);
    sheet.appendChild(body);
    sheet.appendChild(footer);

    // IMPORTANT:
    // Shopify dynamic checkout buttons often require being inside the product form.
    // On mobile we move the dropdown menu (and accelerated checkout wrapper) into this
    // sheet. If the sheet is mounted on document.body, the payment buttons end up
    // outside the form and can stop working.
    var parent = mountParent && mountParent.appendChild ? mountParent : document.body;
    parent.appendChild(backdrop);
    parent.appendChild(sheet);

    return {
      sheet: sheet,
      body: body,
      footer: footer,
      footerSize: null,
      footerAddBtn: footerAddBtn,
      footerAccelSlot: footerAccelSlot,
      closeBtn: closeBtn,
      backdrop: backdrop,
    };
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-ymee-variant-dropdown]')
      .forEach(function (root) {
        if (root.dataset.ymeeBound === 'true') return;
        root.dataset.ymeeBound = 'true';

        var sectionId = root.getAttribute('data-section-id');
        if (!sectionId) return;

        var sectionRoot =
          root.closest('.product-template[data-section-id="' + cssEscape(sectionId) + '"]') || document;

        var isPurchaseRestrictedMarket =
          sectionRoot.getAttribute('data-purchase-restricted-market') === 'true';

        var pdpYmalContainer = sectionRoot.querySelector('.pdp__ymal, [data-pdp-ymal-container] ');

        sectionRoot.setAttribute('data-ymee-variant-dropdown-enabled', 'true');

        var isGiftCardTemplate = false;
        try {
          isGiftCardTemplate = document.body && document.body.classList && document.body.classList.contains('template-product-gift-card');
        } catch (e) {
          isGiftCardTemplate = false;
        }

        // Gift card PDP requirement: keep price hidden until user explicitly selects a variant
        // from the YMEE dropdown menu.
        if (isGiftCardTemplate) {
          sectionRoot.setAttribute('data-ymee-giftcard-price-unlocked', 'false');
        }

        var toggle = root.querySelector('.ymee-variant-dropdown__toggle');
        var menu = root.querySelector('.ymee-variant-dropdown__menu');
        var valueEl = root.querySelector('[data-ymee-variant-dropdown-value]');
        var placeholderEl = root.querySelector('[data-ymee-variant-dropdown-placeholder]');
        var selectEl = sectionRoot.querySelector('#ProductSelect--' + cssEscape(sectionId));
        var formEl = sectionRoot.querySelector('#AddToCartForm--' + cssEscape(sectionId));
        var bisTrigger = sectionRoot.querySelector('#BIS_trigger');
        var variantSelectEl =
          selectEl ||
          (formEl ? formEl.querySelector('select[name="id"]') : null) ||
          sectionRoot.querySelector('select[name="id"]');

        var accelWrapper = null;
        function resolveAcceleratedCheckoutWrapper() {
          if (accelWrapper && document.contains(accelWrapper)) return accelWrapper;

          // Prefer scoping to the current product form (prevents grabbing quick-buy/drawer instances).
          var found = null;
          if (formEl) found = formEl.querySelector('.accelerated-checkout-wrapper.pdp');
          if (!found) found = sectionRoot.querySelector('.accelerated-checkout-wrapper.pdp');
          if (!found) found = root.querySelector('.accelerated-checkout-wrapper.pdp');

          accelWrapper = found;

          if (accelWrapper && !accelWrapper.dataset.ymeeHome) {
            accelWrapper.dataset.ymeeHome = 'true';
            accelWrapper.dataset.ymeeHomeParentSelector = '.product__form__sticky-bottom .product__form__submit';
            accelWrapper.dataset.ymeeHomeNextSelector =
              '[data-btn-add-to-cart], #AddToCart--' + cssEscape(sectionId);
          }

          return accelWrapper;
        }

        if (!toggle || !menu) return;

        var sheetState = null;
        var paymentReady = false;
        var paymentReadyObserver = null;
        var paymentInitRequested = false;
        var lastHoverVariantId = null;
        var hoverSyncRaf = 0;
        var menuHomeParent = menu.parentElement;
        var menuHomeNext = menu.nextSibling;
        var dropdownHomeParent = root.parentElement;
        var dropdownHomeNext = root.nextSibling;
        var escHandlerBound = false;

        function getSelectedOptionEl() {
          var optionScope = (menu && typeof menu.querySelector === 'function') ? menu : root;

          // Prefer the currently selected variant from the real product form.
          // This keeps mobile sheet actions aligned with the PDP state even when
          // we intentionally clear the visual row selection on sheet open.
          if (variantSelectEl && variantSelectEl.value) {
            var byVariant = optionScope.querySelector(
              '.ymee-variant-dropdown__option[data-variant-id="' + cssEscape(variantSelectEl.value) + '"]'
            );
            if (byVariant) return byVariant;
          }

          return (
            optionScope.querySelector('.ymee-variant-dropdown__option.is-selected') ||
            optionScope.querySelector('.ymee-variant-dropdown__option:not(.is-oos)') ||
            optionScope.querySelector('.ymee-variant-dropdown__option')
          );
        }

        function clearSelectedVisual() {
          try {
            menu.querySelectorAll('.ymee-variant-dropdown__option').forEach(function (el) {
              el.classList.remove('is-selected');
              el.setAttribute('aria-selected', 'false');
            });
          } catch (e) {
            // no-op
          }
        }

        function ensureSheetFooterCopy() {
          if (isPurchaseRestrictedMarket) return;
          if (!sheetState || !sheetState.footerAddBtn) return;
          var sourceBtn = root.querySelector('[data-btn-add-to-cart]');
          if (!sourceBtn) return;
          if (sheetState.footerAddBtn.dataset.ymeeCloned === 'true') return;

          sheetState.footerAddBtn.dataset.ymeeCloned = 'true';
          try {
            sheetState.footerAddBtn.innerHTML = sourceBtn.innerHTML;
          } catch (e) {
            sheetState.footerAddBtn.textContent = sourceBtn.textContent || 'Add to cart';
          }
        }

        function updateSheetFooterState() {
          if (!sheetState) return;

          if (isPurchaseRestrictedMarket) {
            if (sheetState.footer) sheetState.footer.hidden = true;
            if (sheetState.footerAddBtn) sheetState.footerAddBtn.disabled = true;
            if (sheetState.footerAccelSlot) sheetState.footerAccelSlot.hidden = true;
            restoreAcceleratedCheckoutHome();
            return;
          }

          var selected = getSelectedOptionEl();
          var optionScope = (menu && typeof menu.querySelector === 'function') ? menu : root;
          var visualSelected = optionScope.querySelector('.ymee-variant-dropdown__option.is-selected');

          // Mobile sheet: show footer actions only after the user selects a row.
          if (isMobileViewport()) {
            if (sheetState.footer) sheetState.footer.hidden = !visualSelected;
            if (!visualSelected) {
              if (sheetState.footerAddBtn) sheetState.footerAddBtn.disabled = true;
              if (sheetState.footerAccelSlot) sheetState.footerAccelSlot.hidden = true;
              restoreAcceleratedCheckoutHome();
              return;
            }
            selected = visualSelected;
          }

          if (!selected) return;

          if (sheetState.footerSize) {
            var opt1 = selected.getAttribute('data-option1') || '';
            sheetState.footerSize.textContent = opt1 ? String(opt1) : '';
          }

          if (sheetState.footerAddBtn) {
            var isOos = selected.classList.contains('is-oos');
            sheetState.footerAddBtn.disabled = !!isOos;
          }


          // Wallet buttons should not be shown for OOS variants.
          var selectedIsOos = selected.classList.contains('is-oos');
          if (sheetState.footerAccelSlot) {
            sheetState.footerAccelSlot.hidden = !!selectedIsOos;
          }

          // If OOS, restore the wallet buttons back to their home container.
          // Keeping them mounted in a hidden footer can be unstable in some wallet implementations.
          if (selectedIsOos) {
            restoreAcceleratedCheckoutHome();
          }
        }

        function mountAcceleratedCheckoutIntoSheetFooter() {
          if (isPurchaseRestrictedMarket) return;
          if (!sheetState || !sheetState.footerAccelSlot) return;
          if (sheetState.footerAccelSlot.hidden) return;
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;

          if (wrapper.parentElement === sheetState.footerAccelSlot) return;

          try {
            sheetState.footerAccelSlot.innerHTML = '';
          } catch (e) {
            // no-op
          }
          sheetState.footerAccelSlot.appendChild(wrapper);
        }

        function restoreDropdownHome() {
          if (!dropdownHomeParent) return;
          if (root.parentElement === dropdownHomeParent) return;
          if (dropdownHomeNext && dropdownHomeNext.parentNode === dropdownHomeParent) {
            dropdownHomeParent.insertBefore(root, dropdownHomeNext);
          } else {
            dropdownHomeParent.appendChild(root);
          }
        }

        function mountDropdownIntoMobileNavbar() {
          var mount = document.querySelector('[data-ymee-mobile-variant-dropdown-mount]');
          if (!mount) return;
          if (!isMobileViewport()) {
            restoreDropdownHome();
            return;
          }

          // If another instance is already mounted here, do not steal the slot.
          if (mount.children && mount.children.length && mount.children[0] !== root) return;
          if (root.parentElement === mount) return;
          mount.appendChild(root);
        }

        var navbarMountRaf = 0;
        function scheduleNavbarMountSync() {
          if (navbarMountRaf) return;
          navbarMountRaf = requestAnimationFrame(function () {
            navbarMountRaf = 0;
            mountDropdownIntoMobileNavbar();
          });
        }

        var sizeOptionEl = sectionRoot.querySelector('.product__form__option.product__form__option--size');
        var sizeOptionHomeParent = sizeOptionEl ? sizeOptionEl.parentElement : null;
        var sizeOptionHomeNext = sizeOptionEl ? sizeOptionEl.nextSibling : null;
        var sizeOptionMount = null;
        var sizeOptionReadyObserver = null;

        function isSizeOptionReady() {
          if (!sizeOptionEl) return false;
          // szb-container is injected dynamically by the size/fit helper.
          // Wait until it appears so we don't move the host node too early.
          if (sizeOptionEl.querySelector('.szb-container')) return true;

          // Fallback: consider it ready if it has any interactive controls rendered.
          if (sizeOptionEl.querySelector('input[type="radio"], input[type="checkbox"], select')) return true;
          return false;
        }

        function getRestrictedMarketMessageHtml() {
          var inlineMessage = sectionRoot.querySelector('[data-market-purchase-restriction]');
          if (inlineMessage && inlineMessage.innerHTML) return inlineMessage.innerHTML;

          var mobileMetaMessage = sectionRoot.querySelector('#product__meta__add-to-cart--mobile');
          if (mobileMetaMessage && mobileMetaMessage.innerHTML) return mobileMetaMessage.innerHTML;

          return '';
        }

        function whenSizeOptionReady(cb) {
          if (typeof cb !== 'function') return;
          if (!sizeOptionEl) return;
          if (isSizeOptionReady()) {
            cb();
            return;
          }

          if (sizeOptionReadyObserver) return;

          try {
            sizeOptionReadyObserver = new MutationObserver(function () {
              if (!sizeOptionEl) return;
              if (!isSizeOptionReady()) return;
              try {
                sizeOptionReadyObserver.disconnect();
              } catch (e) {
                // no-op
              }
              sizeOptionReadyObserver = null;
              cb();
            });
            sizeOptionReadyObserver.observe(sizeOptionEl, { childList: true, subtree: true });
          } catch (e) {
            // no-op
          }

          // Fallback timeout so the dropdown still works if szb doesn't load.
          setTimeout(function () {
            if (!sizeOptionEl) return;
            if (!sizeOptionReadyObserver) return;
            try {
              sizeOptionReadyObserver.disconnect();
            } catch (err) {
              // no-op
            }
            sizeOptionReadyObserver = null;
            cb();
          }, 1500);
        }

        function mountSizeOptionIntoMenu() {
          if (!sizeOptionEl || !menu) return;

          if (!sizeOptionMount) {
            sizeOptionMount = document.createElement('div');
            sizeOptionMount.className = 'ymee-variant-dropdown__size-options';
            sizeOptionMount.setAttribute('data-ymee-size-options', '');
            menu.appendChild(sizeOptionMount);
          }

          if (sizeOptionEl.parentElement !== sizeOptionMount) {
            sizeOptionMount.appendChild(sizeOptionEl);
          }

          // Ensure controls remain associated with the product form even after moving
          // out of the form element.
          if (formEl && formEl.id) {
            try {
              sizeOptionEl.querySelectorAll('input, select, textarea').forEach(function (control) {
                control.setAttribute('form', formEl.id);
              });
            } catch (e) {
              // no-op
            }
          }
        }

        function closeSheet() {
          if (!sheetState) return;
          try {
            document.documentElement.classList.remove('ymee-variant-sheet-open');
          } catch (e) {
            // no-op
          }
          if (sheetState.backdrop) sheetState.backdrop.removeEventListener('click', closeMenu);
          if (sheetState.closeBtn) sheetState.closeBtn.removeEventListener('click', closeMenu);

          var sheetEl = sheetState.sheet;
          var backdropEl = sheetState.backdrop;
          var hideDone = false;
          var finishHide = function () {
            if (hideDone) return;
            hideDone = true;
            if (backdropEl) backdropEl.hidden = true;
            if (sheetEl) sheetEl.hidden = true;
          };

          // Hide after transition so it slides down smoothly
          if (sheetEl && typeof sheetEl.addEventListener === 'function') {
            var onEnd = function (evt) {
              if (evt && evt.target !== sheetEl) return;
              sheetEl.removeEventListener('transitionend', onEnd);
              finishHide();
            };
            sheetEl.addEventListener('transitionend', onEnd);
            setTimeout(function () {
              sheetEl.removeEventListener('transitionend', onEnd);
              finishHide();
            }, 350);
          } else {
            finishHide();
          }

          // move menu back
          if (menuHomeParent) {
            if (menuHomeNext && menuHomeNext.parentNode === menuHomeParent) {
              menuHomeParent.insertBefore(menu, menuHomeNext);
            } else {
              menuHomeParent.appendChild(menu);
            }
          }

          // move size option block back (keeps DOM structure stable outside dropdown)
          if (sizeOptionEl && sizeOptionHomeParent) {
            if (sizeOptionHomeNext && sizeOptionHomeNext.parentNode === sizeOptionHomeParent) {
              sizeOptionHomeParent.insertBefore(sizeOptionEl, sizeOptionHomeNext);
            } else {
              sizeOptionHomeParent.appendChild(sizeOptionEl);
            }
          }
          menu.hidden = true;
          sheetState = null;
        }

        function closeMenu() {
          if (sheetState) {
            closeSheet();
          } else {
            menu.hidden = true;
          }

          toggle.setAttribute('aria-expanded', 'false');

          // If we moved the size option block into the dropdown menu, restore it on close.
          if (sizeOptionEl && sizeOptionHomeParent) {
            if (sizeOptionHomeNext && sizeOptionHomeNext.parentNode === sizeOptionHomeParent) {
              sizeOptionHomeParent.insertBefore(sizeOptionEl, sizeOptionHomeNext);
            } else {
              sizeOptionHomeParent.appendChild(sizeOptionEl);
            }
          }

          // Ensure the real Shopify payment buttons return to the PDP home position
          // after the dropdown closes.
          restoreAcceleratedCheckoutHome();
        }

        function scrollToPaymentButtons() {
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;
          try {
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (e) {
            // no-op
          }
        }

        function mountAcceleratedCheckoutIntoOption(optionEl) {
          if (!optionEl) return;
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;
          var slot = optionEl.querySelector('[data-ymee-accelerated-slot]');
          if (!slot) return;

          if (wrapper.parentElement === slot) return;

          // Keep slot clean and move the single real wrapper into the active row.
          try {
            slot.innerHTML = '';
          } catch (e) {
            // no-op
          }
          slot.appendChild(wrapper);
        }

        function isPaymentButtonReady() {
          if (paymentReady) return true;
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return false;
          var spb = wrapper.querySelector('.shopify-payment-button');
          if (!spb) return false;

          // Shopify may render different structures depending on enabled wallets.
          if (
            spb.querySelector(
              '.shopify-payment-button__button, .shopify-payment-button__more-options, iframe, button, input[type="submit"], input[type="button"], a'
            )
          ) {
            paymentReady = true;
            return true;
          }
          return false;
        }

        function whenPaymentReady(cb) {
          if (typeof cb !== 'function') return;
          if (isPaymentButtonReady()) {
            cb();
            return;
          }

          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;

          // Best-effort init, but ONLY ONCE (re-init can break accelerated checkout buttons).
          if (!paymentInitRequested) {
            paymentInitRequested = true;
            try {
              if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
                window.Shopify.PaymentButton.init();
              }
            } catch (e) {
              // no-op
            }
          }

          var done = false;
          var finish = function () {
            if (done) return;
            done = true;
            try {
              if (paymentReadyObserver) paymentReadyObserver.disconnect();
            } catch (e) {
              // no-op
            }
            paymentReadyObserver = null;
            cb();
          };

          if (paymentReadyObserver) return;

          try {
            paymentReadyObserver = new MutationObserver(function () {
              if (isPaymentButtonReady()) finish();
            });
            paymentReadyObserver.observe(wrapper, { childList: true, subtree: true, attributes: true });
          } catch (e) {
            // no-op
          }

          // Fallback timeout in case observer doesn't fire
          setTimeout(function () {
            if (isPaymentButtonReady()) finish();
          }, 2000);
          setTimeout(function () {
            if (isPaymentButtonReady()) finish();
          }, 5000);
        }

        function tryAutoTriggerPreferredExpress() {
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;

          // We intentionally do NOT click .shopify-payment-button__more-options here because
          // it often redirects to the regular checkout flow.

          var tryClick = function (el) {
            try {
              if (el && typeof el.click === 'function' && !el.disabled) {
                el.click();
                return true;
              }
            } catch (e) {
              // no-op
            }
            return false;
          };

          // Strategy 1: try to find PayPal / Apple Pay by accessible label/text
          var paypalBtn = findPaymentTargetByMethod('paypal');
          if (tryClick(paypalBtn)) return;

          var appleBtn = findPaymentTargetByMethod('applepay');
          if (tryClick(appleBtn)) return;

          // Strategy 2: click first primary payment button (not "more options") if present
          var primary = wrapper.querySelector(
            '.shopify-payment-button__button:not(.shopify-payment-button__more-options)'
          );
          if (tryClick(primary)) return;
        }

        function triggerPrimaryPaymentButton() {
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;

          var tryClick = function () {
            var primary = wrapper.querySelector(
              '.shopify-payment-button__button:not(.shopify-payment-button__more-options)'
            );
            if (primary && !primary.disabled) {
              try {
                primary.click();
                return true;
              } catch (e) {
                return false;
              }
            }
            return false;
          };

          // Shopify may render/enable this control async after a variant change.
          if (tryClick()) return true;
          setTimeout(tryClick, 120);
          setTimeout(tryClick, 280);
          setTimeout(tryClick, 600);
          setTimeout(tryClick, 1000);
          return false;
        }

        function openSheet() {
          // Mount the sheet inside the PDP form/section so payment buttons remain in-form.
          sheetState = createSheet(sectionId, formEl || sectionRoot);
          if (!sheetState || !sheetState.body) return;

          if (sheetState.backdrop) sheetState.backdrop.hidden = false;
          if (sheetState.sheet) sheetState.sheet.hidden = false;

          // move menu into sheet
          sheetState.body.innerHTML = '';

          if (isMobileViewport() && isPurchaseRestrictedMarket) {
            var restrictionMessageEl = document.createElement('div');
            restrictionMessageEl.className = 'market-purchase-restriction-message';
            restrictionMessageEl.setAttribute('data-market-purchase-restriction', '');
            restrictionMessageEl.innerHTML = getRestrictedMarketMessageHtml();
            sheetState.body.appendChild(restrictionMessageEl);
          }

          sheetState.body.appendChild(menu);
          menu.hidden = false;

          // On open: restore visual selection if user already picked a size; otherwise clear.
          var alreadySelected = isMobileViewport() && sectionRoot.getAttribute('data-ymee-variant-selected') === 'true';
          if (alreadySelected) {
            var preselect = getSelectedOptionEl();
            if (preselect) setSelectedVisual(preselect);
            else clearSelectedVisual();
          } else {
            clearSelectedVisual();
          }

          ensureSheetFooterCopy();
          updateSheetFooterState();

          if (isPurchaseRestrictedMarket && sheetState.footer) {
            sheetState.footer.hidden = true;
          }

          try {
            // Ensure the slide-up transition runs by adding the class on the next frame.
            document.documentElement.classList.remove('ymee-variant-sheet-open');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                document.documentElement.classList.add('ymee-variant-sheet-open');
              });
            });
          } catch (e) {
            // no-op
          }

          if (sheetState.backdrop) sheetState.backdrop.addEventListener('click', closeMenu);
          if (sheetState.closeBtn) sheetState.closeBtn.addEventListener('click', closeMenu);

          // Mobile Option C: keep a single accelerated checkout instance in the sheet footer.
          whenPaymentReady(function () {
            mountAcceleratedCheckoutIntoSheetFooter();
            setTimeout(function () {
              mountAcceleratedCheckoutIntoSheetFooter();
            }, 300);
          });

          if (sheetState.footerAddBtn && !sheetState.footerAddBtn.dataset.ymeeBound) {
            sheetState.footerAddBtn.dataset.ymeeBound = 'true';
            sheetState.footerAddBtn.addEventListener('click', function (e) {
              if (!isMobileViewport()) return;
              if (isPurchaseRestrictedMarket) return;
              e.preventDefault();
              e.stopPropagation();

              var selected = getSelectedOptionEl();
              if (selected) syncVariant(selected);
              updateSheetFooterState();
              if (sheetState && !sheetState.footerAccelSlot.hidden) {
                mountAcceleratedCheckoutIntoSheetFooter();
              }
              closeMenu();

              setTimeout(function () {
                try {
                  if (formEl && typeof formEl.requestSubmit === 'function') {
                    formEl.requestSubmit();
                    return;
                  }
                } catch (err) {
                  // no-op
                }

                try {
                  var realSubmit = formEl
                    ? formEl.querySelector('button[type="submit"], input[type="submit"]')
                    : null;
                  if (realSubmit && typeof realSubmit.click === 'function') realSubmit.click();
                } catch (err2) {
                  // no-op
                }
              }, 0);
            });
          }

          if (!escHandlerBound) {
            escHandlerBound = true;
            document.addEventListener('keydown', function (evt) {
              if (!sheetState) return;
              if (evt.key === 'Escape' || evt.key === 'Esc') {
                closeMenu();
              }
            });
          }
        }

        function openMenu() {
          if (isMobileViewport()) {
            openSheet();
          } else {
            menu.hidden = false;
          }
          toggle.setAttribute('aria-expanded', 'true');

          whenSizeOptionReady(function () {
            // If the dropdown was closed before dynamic content loaded, don't mount.
            if (toggle.getAttribute('aria-expanded') !== 'true') return;
            mountSizeOptionIntoMenu();
          });

          // Desktop only: move accelerated checkout into hovered/selected rows.
          whenPaymentReady(function () {
            if (isMobileViewport()) {
              if (sheetState) mountAcceleratedCheckoutIntoSheetFooter();
              return;
            }
            if (menu.hidden) return;
            var selected = getSelectedOptionEl();
            if (selected) mountAcceleratedCheckoutIntoOption(selected);
            setTimeout(function () {
              if (!menu.hidden && selected) mountAcceleratedCheckoutIntoOption(selected);
            }, 300);
          });
        }

        function setSelectedVisual(optionEl) {
          menu.querySelectorAll('.ymee-variant-dropdown__option').forEach(function (el) {
            el.classList.toggle('is-selected', el === optionEl);
            el.setAttribute('aria-selected', el === optionEl ? 'true' : 'false');
          });
        }

        function syncVariant(optionEl, opts) {
          if (!optionEl) return;
          opts = opts || {};

          var variantId = optionEl.getAttribute('data-variant-id');
          var opt1 = optionEl.getAttribute('data-option1');

          // UX: when user selects a variant from the dropdown (without buying),
          // show the selected value instead of the placeholder text, and reveal
          // the sticky-bottom submit buttons under the dropdown.
          if (opts && opts.userSelected) {
            try {
              sectionRoot.setAttribute('data-ymee-variant-selected', 'true');
            } catch (e) {
              // no-op
            }

            try {
              if (placeholderEl) {
                var label = opt1;
                if (!label) {
                  var sizeEl = optionEl.querySelector('.ymee-variant-dropdown__size');
                  label = sizeEl ? (sizeEl.textContent || '').trim() : '';
                }
                if (label) {
                  if (isMobileViewport()) {
                    var selectLabel = (typeof window.selectSizeText === 'string' && window.selectSizeText) || 'Select size';
                    placeholderEl.textContent = selectLabel + ': ' + label;
                    if (valueEl) valueEl.textContent = selectLabel + ': ' + label;
                  } else {
                    placeholderEl.textContent = label;
                  }
                }
              }
            } catch (e2) {
              // no-op
            }
          }

          // Placeholder text should always be shown; selected value is intentionally hidden.
          setSelectedVisual(optionEl);

          // Unlock price visibility only after an explicit user selection.
          if (isGiftCardTemplate && opts && opts.userSelected) {
            try {
              sectionRoot.setAttribute('data-ymee-giftcard-price-unlocked', 'true');
            } catch (e) {
              // no-op
            }
          }

          if (opt1) {
            // Prefer the specific "taglia" option input id when it exists.
            // Theme renders: id="ProductSelect-option-{{ option.name | handleize }}-{{ value | handleize }}"
            var tagliaId = 'ProductSelect-option-taglia-' + handleize(opt1);
            var radio =
              (formEl ? formEl.querySelector('#' + cssEscape(tagliaId)) : null) ||
              sectionRoot.querySelector('#' + cssEscape(tagliaId));

            // Fallback: any ProductSelect-option-* radio with matching value
            if (!radio) {
              radio =
                (formEl
                  ? formEl.querySelector('input[type="radio"][id^="ProductSelect-option-"][value="' + cssEscape(opt1) + '"]')
                  : null) ||
                sectionRoot.querySelector(
                  'input[type="radio"][id^="ProductSelect-option-"][value="' + cssEscape(opt1) + '"]'
                );
            }

            // Last fallback: old theme pattern
            if (!radio) {
              radio =
                (formEl
                  ? formEl.querySelector('input[name="option1"][value="' + cssEscape(opt1) + '"]')
                  : null) ||
                sectionRoot.querySelector('input[name="option1"][value="' + cssEscape(opt1) + '"]');
            }

            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('input', { bubbles: true }));
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          // Finally: ensure select[name="id"] matches the chosen variant.
          // We do this after updating radios so the theme's variant logic can run first.
          if (!opts.skipSelect && variantSelectEl && variantId) {
            if (String(variantSelectEl.value) !== String(variantId)) {
              variantSelectEl.value = variantId;
              variantSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        function syncFromSelect() {
          if (!variantSelectEl) return;
          var variantId = variantSelectEl.value;
          if (!variantId) return;
          var optionEl = root.querySelector(
            '.ymee-variant-dropdown__option[data-variant-id="' + cssEscape(variantId) + '"]'
          );
          // Programmatic sync (page load / other scripts). Do NOT unlock price.
          if (optionEl) syncVariant(optionEl);

          if (isMobileViewport() && sheetState) {
            updateSheetFooterState();
            whenPaymentReady(function () {
              mountAcceleratedCheckoutIntoSheetFooter();
            });
          }
        }

        function restoreAcceleratedCheckoutHome() {
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return;

          var parentSelector = wrapper.dataset.ymeeHomeParentSelector;
          var nextSelector = wrapper.dataset.ymeeHomeNextSelector;
          var parent = parentSelector ? sectionRoot.querySelector(parentSelector) : null;

          if (!parent) return;

          // If already in the intended home container, do nothing.
          if (wrapper.parentElement === parent) {
            wrapper.dataset.ymeeHomeRestored = 'true';
            return;
          }

          var nextEl = nextSelector ? parent.querySelector(nextSelector) : null;
          if (nextEl && nextEl.parentNode === parent) {
            parent.insertBefore(wrapper, nextEl.nextSibling);
          } else {
            parent.appendChild(wrapper);
          }

          wrapper.dataset.ymeeHomeRestored = 'true';

          try {
            if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
              window.Shopify.PaymentButton.init();
            }
          } catch (e) {
            // no-op
          }
        }

        function getPaymentButtonTargets() {
          var wrapper = resolveAcceleratedCheckoutWrapper();
          if (!wrapper) return [];
          var spb = wrapper.querySelector('.shopify-payment-button');
          if (!spb) return [];
          var nodes = spb.querySelectorAll('button, a, iframe, input[type="submit"], input[type="button"]');
          return Array.prototype.slice.call(nodes || []).filter(function (el) {
            if (!el) return false;
            if (el.tagName !== 'IFRAME' && el.disabled) return false;
            // Exclude our own controls if any
            if (el.closest && el.closest('[data-ymee-variant-dropdown]')) return false;
            return true;
          });
        }

        function labelForTarget(el) {
          if (!el) return '';
          var aria = el.getAttribute && el.getAttribute('aria-label');
          if (aria) return aria;
          if (el.tagName === 'IFRAME') {
            var title = el.getAttribute && el.getAttribute('title');
            if (title) return title;
          }
          if (el.tagName === 'INPUT') return el.value || '';
          return (el.textContent || '').trim();
        }

        function methodClassFromLabel(label) {
          var l = String(label || '').toLowerCase();
          if (l.indexOf('paypal') !== -1) return 'is-paypal';
          if (l.indexOf('apple') !== -1) return 'is-applepay';
          if (l.indexOf('google') !== -1 || l.indexOf('gpay') !== -1) return 'is-gpay';
          if (l.indexOf('shop') !== -1) return 'is-shoppay';
          return 'is-express';
        }

        function methodKeyFromLabel(label) {
          var l = String(label || '').toLowerCase();
          if (l.indexOf('paypal') !== -1) return 'paypal';
          if (l.indexOf('apple') !== -1) return 'applepay';
          if (l.indexOf('google') !== -1 || l.indexOf('gpay') !== -1) return 'gpay';
          if (l.indexOf('shop') !== -1) return 'shoppay';
          if (l.indexOf('altre opzioni') !== -1 || l.indexOf('more options') !== -1) return 'more';
          return 'express';
        }

        function findPaymentTargetByMethod(methodKey) {
          var targets = getPaymentButtonTargets();
          if (!targets.length) return null;
          if (!methodKey) return targets[0];

          var found = null;
          targets.some(function (t) {
            var key = methodKeyFromLabel(labelForTarget(t));
            if (key === methodKey) {
              found = t;
              return true;
            }
            return false;
          });
          return found || targets[0];
        }

        function buildExpressProxyButtons(optionEl) {
          if (!optionEl) return;
          var container = optionEl.querySelector('[data-ymee-express-proxy]');
          if (!container) return;

          // Simplified UX: show ONLY one entrypoint per row.
          // User hovers row to preselect size, then clicks this to trigger Shopify's real
          // accelerated checkout primary button.
          var wrapper = resolveAcceleratedCheckoutWrapper();
          var spb = wrapper ? wrapper.querySelector('.shopify-payment-button') : null;
          if (!spb) {
            container.innerHTML = '';
            return;
          }

          container.innerHTML = '';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ymee-variant-dropdown__express-btn is-more is-express';
          btn.textContent = 'Altre opzioni di pagamento';
          btn.setAttribute('data-ymee-express-btn', '');
          btn.setAttribute('data-target-index', '0');
          btn.setAttribute('data-target-method', 'more');
          container.appendChild(btn);
        }

        function refreshAllExpressProxyButtons() {
          menu.querySelectorAll('.ymee-variant-dropdown__option').forEach(function (opt) {
            if (opt.classList.contains('is-oos')) return;
            if (!opt.querySelector('[data-ymee-express-proxy]')) return;
            buildExpressProxyButtons(opt);
          });
        }

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (menu.hidden) openMenu();
          else closeMenu();
        });

        document.addEventListener('click', function (e) {
          if (sheetState) return;
          if (!root.contains(e.target)) closeMenu();
        });

        mountDropdownIntoMobileNavbar();
        window.addEventListener('resize', scheduleNavbarMountSync);
        try {
          var navMq = window.matchMedia('(max-width: 1024px)');
          if (navMq && navMq.addEventListener) navMq.addEventListener('change', scheduleNavbarMountSync);
          else if (navMq && navMq.addListener) navMq.addListener(scheduleNavbarMountSync);
        } catch (e) {
          // no-op
        }

        // Mobile PDP CTA should open the sheet instead of triggering add-to-cart/back-in-stock.
        var mobileCta = sectionRoot.querySelector('.product__meta__add-to-cart--mobile');
        if (mobileCta) {
          mobileCta.addEventListener(
            'click',
            function (e) {
              if (!isMobileViewport()) return;
              // Only override behavior if dropdown exists in this section
              if (!root || !root.matches('[data-ymee-variant-dropdown]')) return;
              e.preventDefault();
              e.stopPropagation();
              openMenu();
            },
            true
          );
        }

        menu.addEventListener(
          'click',
          function (e) {
            var optionEl = e.target.closest('.ymee-variant-dropdown__option');

            // If user clicks a real Shopify wallet button, sync the variant first but
            // do not prevent the wallet click.
            if (
              e.target.closest('.accelerated-checkout-wrapper') ||
              e.target.closest('.shopify-payment-button') ||
              e.target.closest('shopify-accelerated-checkout')
            ) {
              if (optionEl && !optionEl.classList.contains('is-oos')) {
                syncVariant(optionEl, { userSelected: true });
                if (!isMobileViewport()) {
                  mountAcceleratedCheckoutIntoOption(optionEl);
                }
                if (isMobileViewport() && sheetState) {
                  updateSheetFooterState();
                  mountAcceleratedCheckoutIntoSheetFooter();
                }
              }
              return;
            }

            var expressBtn = e.target.closest('[data-ymee-express-btn]');
            if (expressBtn) {
              var optionEl = e.target.closest('.ymee-variant-dropdown__option');
              if (!optionEl) return;
              e.preventDefault();
              e.stopPropagation();
              syncVariant(optionEl, { userSelected: true });

              var methodKey = expressBtn.getAttribute('data-target-method') || '';

              // Close dropdown and trigger the real Shopify payment button (no modal)
              closeMenu();

              whenPaymentReady(function () {
                // Give Shopify a moment to react to variant change (wallet buttons can be disabled while updating).
                setTimeout(function () {
                  if (methodKey === 'more') {
                    // Trigger the native Shopify accelerated checkout primary button.
                    // If wallets are iframe-based, we can't click them reliably; scroll instead.
                    var did = triggerPrimaryPaymentButton();
                    if (!did) scrollToPaymentButtons();
                    return;
                  }

                  var target = findPaymentTargetByMethod(methodKey);
                  if (target && typeof target.click === 'function' && !target.disabled) {
                    try {
                      target.click();
                      return;
                    } catch (e) {
                      // no-op
                    }
                  }

                  // Some wallet buttons are iframe-based and cannot be programmatically clicked.
                  // In that case scroll the real payment buttons into view.
                  scrollToPaymentButtons();
                }, 120);
              });

              return;
            }

            if (!optionEl) return;

            var addBtn = e.target.closest('[data-btn-add-to-cart], button[type="submit"], input[type="submit"]');
            if (addBtn) {
              e.preventDefault();
              e.stopPropagation();

              // Ensure variant selection is synced before submit.
              syncVariant(optionEl, { userSelected: true });
              mountAcceleratedCheckoutIntoOption(optionEl);
              closeMenu();

              // Submit the real PDP product form programmatically.
              setTimeout(function () {
                try {
                  if (formEl && typeof formEl.requestSubmit === 'function') {
                    formEl.requestSubmit();
                    return;
                  }
                } catch (err) {
                  // no-op
                }

                try {
                  // Fallback: click a real submit button inside the PDP form.
                  var realSubmit = formEl
                    ? formEl.querySelector('button[type="submit"], input[type="submit"]')
                    : null;
                  if (realSubmit && typeof realSubmit.click === 'function') realSubmit.click();
                } catch (err2) {
                  // no-op
                }
              }, 0);

              return;
            }

            var actionBtn = e.target.closest('[data-action]');

            e.preventDefault();
            e.stopPropagation();

            // Always select variant on any click inside row
            syncVariant(optionEl, { userSelected: true });
            
            // On mobile, if clicking an OOS option row (not the notify button), replace footer add button with notify
            if (isMobileViewport() && optionEl.classList.contains('is-oos') && !e.target.closest('[data-action="notify"]') && !addBtn) {
              // Update sheet footer state
              updateSheetFooterState();
              
              // Hide the disabled add button and insert cloned notify button
              if (sheetState && sheetState.footerAddBtn && sheetState.footerAddBtn.disabled) {
                // First, remove any existing notify button
                var existingNotify = sheetState.footerAddBtn.parentNode.querySelector('[data-action="notify"]');
                if (existingNotify) {
                  existingNotify.remove();
                }
                
                var notifyBtn = optionEl.querySelector('[data-action="notify"]');
                if (notifyBtn) {
                  var clonedBtn = notifyBtn.cloneNode(true);
                  // Apply footer button styling
                  clonedBtn.className = sheetState.footerAddBtn.className + ' ' + notifyBtn.className;
                  clonedBtn.innerHTML = notifyBtn.innerHTML;
                  
                  // Hide the add button and insert the notify button after it
                  sheetState.footerAddBtn.style.display = 'none';
                  sheetState.footerAddBtn.parentNode.insertBefore(clonedBtn, sheetState.footerAddBtn.nextSibling);
                  
                  // Add click handler
                  clonedBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    closeMenu();
                    if (bisTrigger) bisTrigger.click();
                  });
                }
              }
              return;
            }
            
            if (isMobileViewport() && sheetState) {
              updateSheetFooterState();
              // Show the add button again if we're selecting an in-stock option
              if (sheetState.footerAddBtn) {
                if (!optionEl.classList.contains('is-oos')) {
                  sheetState.footerAddBtn.style.display = '';
                }
                // Always remove any notify button that might have been inserted
                var existingNotify = sheetState.footerAddBtn.parentNode.querySelector('[data-action="notify"]');
                if (existingNotify) {
                  existingNotify.remove();
                }
              }
              if (sheetState.footerAccelSlot && !sheetState.footerAccelSlot.hidden) {
                mountAcceleratedCheckoutIntoSheetFooter();
              }
            } else {
              mountAcceleratedCheckoutIntoOption(optionEl);
            }

            var action = actionBtn ? actionBtn.getAttribute('data-action') : null;

            if (action === 'buy') {
              closeMenu();
              if (formEl && typeof formEl.requestSubmit === 'function') {
                formEl.requestSubmit();
              } else {
                var submitBtn = sectionRoot.querySelector('form[action*="/cart/add"] [type="submit"]');
                if (submitBtn) submitBtn.click();
              }
              return;
            }

            if (action === 'notify') {
              closeMenu();
              if (bisTrigger) bisTrigger.click();
              return;
            }

            // Click on row (not on button):
            // - Desktop: select and close (hover already exposes actions)
            // - Mobile: keep sheet open so user can tap add-to-cart / wallet buttons
            if (!isMobileViewport()) {
              closeMenu();
              // If this dropdown is in the desktop sticky bar, scroll to top
              var stickyBanner = root.closest('.product-single__banner.desktop');
              if (stickyBanner) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          },
          true
        );

        // Desktop hover: preselect variant so accelerated checkout buttons are in the correct state
        // before the user clicks PayPal/Apple Pay.
        menu.addEventListener('mouseover', function (e) {
          if (isMobileViewport()) return;
          var optionEl = e.target.closest('.ymee-variant-dropdown__option');
          if (!optionEl || !menu.contains(optionEl)) return;
          if (optionEl.classList.contains('is-oos')) return;

          // Avoid firing repeatedly while moving inside the same row
          if (e.relatedTarget && optionEl.contains(e.relatedTarget)) return;

          var variantId = optionEl.getAttribute('data-variant-id');
          if (!variantId) return;
          if (lastHoverVariantId === variantId) return;
          lastHoverVariantId = variantId;

          if (hoverSyncRaf) {
            try {
              cancelAnimationFrame(hoverSyncRaf);
            } catch (err) {
              // no-op
            }
          }

          hoverSyncRaf = requestAnimationFrame(function () {
            syncVariant(optionEl);
            mountAcceleratedCheckoutIntoOption(optionEl);
          });
        });

        // Shopify renders payment buttons async; don't force-mount while dropdown is closed.
        // Mounting is handled on openMenu/openSheet.
        whenPaymentReady(function () {
          if (menu.hidden) return;
          var selected = getSelectedOptionEl();
          if (selected) mountAcceleratedCheckoutIntoOption(selected);
          setTimeout(function () {
            if (!menu.hidden && selected) mountAcceleratedCheckoutIntoOption(selected);
          }, 300);
        });

        if (selectEl) {
          selectEl.addEventListener('change', function () {
            syncFromSelect();
          });
        }

        // Initial selection
        var initial =
          root.querySelector('.ymee-variant-dropdown__option.is-selected') ||
          root.querySelector('.ymee-variant-dropdown__option');
        if (initial) syncVariant(initial);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
